const Avatar = () => (
  <h1>Avatar</h1>
);

export default Avatar;
